import React from 'react';
import { LayoutRoute } from '../../layout/routes';
import withLoading from '../../helpers/withLoading';

const Game = withLoading(() => import('./'));

const route = <LayoutRoute path="/game/:gameType/:id" component={Game} />;

export default route;
